define(function (require) {
	const tpl = require('../templates/t_cpv_card_view.hbs');
	const itemView = require('./v_itv_data_item');
	const IPSCollection = require('civicsBase/ipsModelCollection');

	return Marionette.CompositeView.extend({
		childEvents:{
			'editItemClicked':'hideEditButtons',
			'editItemDone':'showEditButtons',
			'saveEditsToServer':'saveEdits',
			'clickableClicked':'clickableClicked'
		},
		childView: itemView,
		childViewContainer: ".child-view-container",
		template: tpl,
		/*Marionette Functions*/
		childViewOptions: function () {
			return {
				isModal: this.isModal
			};
		},
		initialize: function (options) {
			this.config = options;
			this.isModal = options.isModal;
			this.collection = new IPSCollection(options.data);
		},
		templateHelpers: function () {
			var self = this;
			return {
				sectionID:this.config.sectionID,
				cardClass:this.config.cardClass,
				numColumnsClass:function(){
					var numColumns = isNaN(self.config.numColumns) ? 2 : self.config.numColumns;
					return 'column-width-'+numColumns;
				},
				title:this.config.title
			};
		},
		/*Marionette Functions*/
		//when an edit button is clicked, we want to hide the other edit buttons.
		hideEditButtons:function(childView){
			//console.log("cpv hiding edits");
			this.collection.each(function(item, index){
				item.set('hideEditButton',true);
			});
		},
		saveEdits:function(childView, model, promise){
			//console.log('CPV saving Edits to server');
			//trigger method on parent view. Note we use triggerMethod not trigger when the parent is a layout viwe.
			this.triggerMethod('saveCardEdits',model, promise);
		},
		//when the user is done editing an item, we want to unhide all the other edits.
		showEditButtons:function(childView){
			//console.log("cpv showing edits");
			this.collection.each(function(item, index){
				item.set('hideEditButton',false);
			});
		},
		clickableClicked:function(childview, funcName){
			//console.log('clickableClicked');
			this.triggerMethod(funcName);
		}
	});
});
